<template>
  <footer>
    <div class="quote">
      <ul>
        <li>
          <h4>
            <p>{{ contact.name }}</p>
          </h4>
          <p>{{ contact.reason }}</p>
          <p>{{ contact.mode }}</p>
          <br />
          <h4>
            <p>{{ opinion.name }}</p>
          </h4>
          <p>{{ opinion.reason }}</p>
          <p>{{ opinion.mode }}</p>
        </li>
        <li>
          <h4>
            <p>{{ wechat }}</p>
          </h4>
          <img src="../images/lingshishifen.png" alt="oopvr" />
        </li>
      </ul>
    </div>
    <div class="information">
      <p>
        <router-link to="/Aboutconfig" :title="{ about }">{{
          about
        }}</router-link>
        <router-link to="/Exemptionconfig" :title="{ statement }">{{
          statement
        }}</router-link>
        <router-link to="/Privacyconfig" :title="{ strategy }">{{
          strategy
        }}</router-link>
        <br />
        <span>{{ copyright }}</span>
        <a
          class="br"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          >{{ cases }}</a
        >
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      contact: {
        name: "联系我们",
        reason: "商务合作,版权纠纷:",
        mode: "微信：OOPVR_97",
      },
      opinion: {
        name: "意见反馈",
        reason: "排版异常,功能bug:",
        mode: "微信：OOPVR_97",
      },

      about: "关于本站",
      statement: "免责声明",
      strategy: "隐私政策",
      wechat: "微信公众号",

      copyright: "© 2019-2021 OOPVR. All Rights Reserved",
      cases: "粤ICP备18118682号-2",
    };
  },
};
</script>

<style lang="less" scoped>
@a-color: rgb(233, 215, 215);
@skeleton-color: rgba(55, 61, 65, 0.733);
footer {
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: @skeleton-color;
  text-align: center;
  color: rgb(235, 229, 229);
  p {
    font-family: "Kalam", cursive;
    font-weight: bold;
    margin: 0;
  }
  .quote {
    padding-top: 20px;
    ul {
      height: 180px;
      display: inline-block;
      li {
        float: left;
        width: 15%;
        height: 100%;
        min-width: 250px;
        text-align: left;
        border-right: rgb(161, 159, 159) solid 1px;
        img {
          width: 150px;
          height: 150px;
          background-color: @a-color;
          border-radius: 5% 5%;
        }
        h4 {
          p {
            color: #000;
          }
        }
        p {
          color: rgb(161, 159, 159);
        }
      }
      li:last-child {
        text-align: center;
        border: none;
      }
    }
  }

  .information {
    padding-top: 30px;
    padding-bottom: 30px;
    font-size: 13px;
    p {
      color: rgb(161, 159, 159);
    }
    a {
      color: @a-color;
    }
    a:hover {
      border-bottom: @a-color 2px solid;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/index/Footer.vue